import { EntityFolder } from './folder';

export interface Reporting {
    reporting_id: string;
    reporting_name: string;
    description: string;
    parameters: {
        [key: string]: {
            type: string,
            required: boolean
        }
    };
    select_values?: {
        [key: string]: [{
            label: string,
            value: string | number | boolean;
        }]
    };
}

export interface EntityRolesTab {
    role_id: string,
    name: string,
    reportings: Reporting[],
    folders: EntityFolder[]
}

export class RolesTab {
    static create (rolesData: EntityRolesTab): RolesTab | null {
        const {
            role_id: roleId,
            name: roleName,
            reportings,
            folders
        } = rolesData;
        
        return new RolesTab(
            roleId,
            roleName,
            reportings,
            folders
        );
    }
    constructor(
        public readonly roleId: string,
        public readonly roleName: string,
        public readonly reportings: Reporting[],
        public readonly folders: EntityFolder[]
    ) {}
}
